import Avatar from 'components/common/Avatar'
import Flex from 'components/common/Flex'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import LockScreenForm from './components/LockScreenForm'
import team1 from 'assets/img/team/1.jpg';
const LockScreen = () => {
  return (
    <Row className="justify-content-center">
        <Col xs="auto">
          <Flex alignItems="center">
            <Avatar src={team1} size="4xl" className="me-4" />
            <div>
              <h4>Hi! Ahmed</h4>
              <p className="mb-0">
                Enter your password <br />
                to access the admin.
              </p>
            </div>
          </Flex>
          <LockScreenForm className="mt-4" />
        </Col>
      </Row>
  )
}

export default LockScreen